import styles from './FinanceDashboard.module.css';
import { PageTitle } from '@round/whitelabel-ui';
import UnallocatedCampaigns from './components/UnallocatedCampaigns/UnallocatedCampaigns';
import CreditLimits from './components/CreditLimits/CreditLimits';
import { useUrlState } from '@round/utils';

const FinanceDashboard = () => {
    const [activeTeamId, setActiveTeamId] = useActiveTeam();

    return (
        <div className={styles.container}>
            <PageTitle>Finance Dashboard</PageTitle>
            <CreditLimits teamId={activeTeamId} onTeamChange={setActiveTeamId} />

            <div className={styles.main}>
                <UnallocatedCampaigns
                    className={styles.unallocatedCampaigns}
                    teamId={activeTeamId}
                    onTeamChange={setActiveTeamId}
                />
            </div>
        </div>
    );
};

export default FinanceDashboard;

/*
 * All sections on finance dashboard share the team filter.
 * Selecting on credit limits applies filter on unallocated campaigns and vice versa.
 */
function useActiveTeam() {
    const { url, mergeSearchParams } = useUrlState<{ team_id: number }>();
    const teamId = url.searchParams.team_id ? Number(url.searchParams.team_id) : null;
    const setTeamId = (teamId: number | null | undefined) => mergeSearchParams({ team_id: teamId });

    return [teamId, setTeamId] as const;
}
